import { render, staticRenderFns } from "./MessageReplyPage.vue?vue&type=template&id=09c73c70&"
import script from "./MessageReplyPage.vue?vue&type=script&lang=ts&"
export * from "./MessageReplyPage.vue?vue&type=script&lang=ts&"
import style0 from "./MessageReplyPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports